import React, {Component} from 'react'
import {connect} from 'react-redux'

import MessageBannerPage from './MessageBannerPage'

import {MessageBannerType} from '@amzn/stencil-react-components/message-banner'

class MaintenanceV2 extends Component {
  
  constructor(props) {
    super(props);
  }

  render() {
    const {maintenance} = this.props;

    const message = {
      type: MessageBannerType.Warning,
      value: maintenance.message
    };

    return (
      <MessageBannerPage
        message={message}
      />
    );
  }
}

const mapState = state => ({
  maintenance: state.maintenance
});

export default connect(mapState, null)(MaintenanceV2);
